export function isMacPlatform(): boolean {
  return navigator.platform.toUpperCase().indexOf("MAC") >= 0;
}
